import { ModuleFE_AdvisorSession } from '@app/advisor-frontend';
import { ModuleFE_BaseAdvisorRuntime } from '@app/advisor-frontend/modules/ModuleFE_BaseAdvisorRuntime';
import { DBDef_RuntimeEncounterFeed } from '@app/advisor-v5-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { sortArray } from '@nu-art/ts-common';
export const dispatch_onRuntimeEncounterFeedUpdated = new ThunderDispatcherV3('__onRuntimeEncounterFeedUpdated');
class ModuleFE_RuntimeEncounterFeed_Class extends ModuleFE_BaseAdvisorRuntime {
    constructor() {
        super(DBDef_RuntimeEncounterFeed, dispatch_onRuntimeEncounterFeedUpdated);
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.encounterFilter);
    }
    getFeedItems = () => {
        const todayCutOff = new Date().setHours(0, 0, 0, 0);
        const feedItems = this.cache.allMutable();
        sortArray(feedItems, i => i.__created, true);
        return {
            today: feedItems.filter(i => i.__created >= todayCutOff),
            older: feedItems.filter(i => i.__created < todayCutOff),
        };
    };
}
export const ModuleFE_RuntimeEncounterFeed = new ModuleFE_RuntimeEncounterFeed_Class();
//# sourceMappingURL=ModuleFE_RuntimeEncounterFeed.js.map